import { adminHttpClient } from '../commons/adminHttpClient'

const lockPremium = (recurringExpenseId: string): Promise<void> => {
  return adminHttpClient.put(`/Expenses/LockRecurringExpenseForReview/${recurringExpenseId}`, {})
}

export default lockPremium
